module.exports = __webpack_public_path__ + "static/media/FranjaApp_Rocket2.efcb367a.png";